import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';
import CheckboxGroup from '../CheckboxGroup';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupWrapper,
    MultipleGroupLast,
    MultipleGroupHalf
} from '../../containers/DefaultStyles/FormDetails';

import {
    getCachedFirstName,
    getCachedMiddleName,
    getCachedLastName
} from '../../utils/formCaching/helpers';
import { validateStep1 } from './validations';

const MultipleGroupWrapperFullRowMobile = styled(MultipleGroupWrapper)`
    @media (max-width: 30em) {
        flex-wrap: wrap;

        .fullRowMobile {
            width: calc(100% - 1em);
            flex: none;
            margin-top: 0.75em;
        }
    }
`;

class VoteRegistrationStep1Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = { class: 'default' };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.setState({ class: 'changed' });
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupWrapperFullRowMobile>
                    <Field
                        name="prefix"
                        component={DropDownSelect}
                        options={this.props.prefix}
                        defaultOption={'Choose'}
                        label="Prefix"
                        type="text"
                    />
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="middleName"
                        component={InputGroup}
                        type="text"
                        label="Middle name"
                        placeholder="Middle Name"
                        autocomplete="off"
                    />
                </MultipleGroupWrapperFullRowMobile>
                <MultipleGroupLast>
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                    <Field
                        name="suffix"
                        component={DropDownSelect}
                        options={this.props.suffix}
                        label="Suffix"
                        type="text"
                    />
                </MultipleGroupLast>
                <MultipleGroupHalf>
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                    <Field
                        name="dateOfBirth"
                        component={InputGroup}
                        type="text"
                        label="Date of birth"
                        placeholder="Date of Birth"
                        autocomplete="off"
                        readOnly={true}
                    />
                </MultipleGroupHalf>
                <MultipleGroupHalf>
                    <Field
                        name="usCitizen"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="I am a us citizen"
                        normalize={v => !!v}
                    />
                    <Field
                        name="hasStateLicense"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="I have a state issued ID"
                        normalize={v => !!v}
                    />
                </MultipleGroupHalf>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                            onClick={this.props.onContinue}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep1Form.propTypes = {
    onBack: PropTypes.func,
    onContinue: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    prefix: PropTypes.array,
    suffix: PropTypes.array,
    handleSubmit: PropTypes.func
};

export default compose(
    connect((state, props) => ({
        initialValues: {
            usCitizen: true,
            hasStateLicense: true,
            getUpdates: true,
            dateOfBirth: props.dateOfBirth,
            prefix: props.prefix.includes(state.cachedFormData.prefix)
                ? state.cachedFormData.prefix
                : '',
            firstName: getCachedFirstName(state),
            middleName: getCachedMiddleName(state),
            lastName: getCachedLastName(state),
            suffix: props.suffix.includes(state.cachedFormData.suffix)
                ? state.cachedFormData.suffix
                : '',
            email: state.cachedFormData.email || ''
        }
    })),
    reduxForm({
        form: 'voteRegistrationStep1Form',
        validate: validateStep1,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep1Form);
